__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-07-1783409481-stable-dev/";